import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { Accordion } from 'components/no-auth/common/accordion/Accordion';
import { PromoDangerouslyHtml } from 'components/no-auth/common/promo-dangerously-html/PromoDangerouslyHtml';
import { PromoText } from 'components/no-auth/common/promo-text/PromoText';
import { PromoSectionContainer } from 'components/no-auth/common/PromoSectionContainer';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

import HeadingSection from './HeadingSection';
import { TextComponent } from './styles';

const Container = styled.section`
    background: ${(props) => promoColors[props.bgColor]};
    padding: ${(props) => (props.noTopPadding ? '0 0 64px 0' : '32px 0 64px')};

    ${promoMedia.tablet744} {
        padding: ${(props) => (props.noTopPadding ? '0 0 96px 0' : '48px 0 96px')};
    }

    ${promoMedia.desktop1440} {
        padding: ${(props) => (props.noTopPadding ? '0 0 128px 0' : '64px 0 128px')};
    }
`;

const FaqSection = ({ bgColor = 'white', ...props }) => {
    const getItems = () => {
        return props.questions.map((q) => ({
            header: <PromoText color={'baseColor'}>{q.title}</PromoText>,
            content: (
                <TextComponent>
                    <PromoDangerouslyHtml color={'baseColor'} dangerouslyHtml={q.text} tag={'div'} />
                </TextComponent>
            ),
            id: q.id,
        }));
    };

    return (
        <Container bgColor={bgColor} noTopPadding={props.noTopPadding}>
            <PromoSectionContainer>
                <HeadingSection title={props.title} noBottomIndent />
                {Array.isArray(props.questions) && <Accordion items={getItems()} sendEvent={props.sendEvent} />}
            </PromoSectionContainer>
        </Container>
    );
};

FaqSection.propTypes = {
    bgColor: PropTypes.oneOf(['baseColor', 'white', 'purple5', 'gray5', 'aubergine01', 'eggshell01', 'eggshell02', 'eggshell03', 'transparent']),
    questions: PropTypes.array,
    title: PropTypes.string,
    noTopPadding: PropTypes.bool,
};
export default FaqSection;
